module.exports = __webpack_public_path__ + "./docs/img/curl.3dac8ab168919e9f35eba2c9d40a4f1a.svg";